<template>
  <div class="module_page page_content institution" aria-label="Institution Configuration view content page">
    <div class="row page-heading">
      <div class="col-8 input module_heading" role="heading" aria-level="1">
        <span class="module_icon ic-inst"></span>
        <label class="head_txt module_type_name institution-title ace_sec_hd">{{institution.displayName}}</label>
        <!-- <label class="head_txt module_type_name institution-title ace_sec_hd"><span v-if="advisorTitle">{{advisorTitle}}: </span>{{institution.title}}</label>
          <label class="head_txt module_type_name ace_sec_hd" v-if="showEntity"> <span class="separator">::</span> {{entity.title}}</label> -->
      </div>
      <div class="col-4 btn_container">
        <b-btn @click="editConfigurationClicked">edit</b-btn>
      </div>
    </div>
    <div class="page_content_container">
      <institution-menu :uuid="uuid" :active="'configuration'"></institution-menu>
      <div class="row pg_content">
        <div class="col-12">
          <div class="row">
            <div class="col-12 pg_fld_sec">
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Current Semester</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.currentSemester}}</label>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Semester Map</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.semesterMap}}</label>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Year Map</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.yearMap}}</label>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Term Map With Cut-Off Date</label>
                  </div>
                  <div class="fld_input">
                    <label class="val" v-if="institution.termMapWithCutOffDate">{{institution.termMapWithCutOffDate}}</label>
                    <label class="val" v-else>{}</label>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Institution Email Recipients</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.emailRecipients}}</label>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Institution Email Sender</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.emailSender}}</label>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Auto Provision</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.autoProvision}}</label>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Auto Provision Role</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.autoProvisionRole}}</label>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Progress Email Cron</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.progressEmailCron}}</label>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Education Level Configuration</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.someHighSchool >= 0">
                    <label class="prog_email_cron_label">Some High School</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.someHighSchool >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.someHighSchool}}</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.highSchool >= 0">
                    <label class="prog_email_cron_label">High School</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.highSchool >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.highSchool}}</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.certificate >= 0">
                    <label class="prog_email_cron_label">Certificate</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.certificate >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.certificate}}</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.associate >= 0">
                    <label class="prog_email_cron_label">Associate</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.associate >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.associate}}</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.bachelor >= 0">
                    <label class="prog_email_cron_label">Bachelor</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.bachelor >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.bachelor}}</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.master >= 0">
                    <label class="prog_email_cron_label">Master</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.master >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.master}}</label>
                  </div>
                  <div class="prog_email_cron_label_top" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.doctoral >= 0">
                    <label class="prog_email_cron_label">Doctoral</label>
                  </div>
                  <div class="fld_input" v-if="institution.educationLevelConfiguration && institution.educationLevelConfiguration.doctoral >= 0">
                    <label class="prog_email_cron_label">{{institution.educationLevelConfiguration.doctoral}}</label>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Guest User Session Count</label>
                  </div>
                  <div class="fld_input">
                    <label class="val">{{institution.guestUserSessionCount}}</label>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Partner Institutions </label>
                  </div>
                  <div class="fld_input">
                    <div class="custom_tags_container">
                      <span class="custom_tag" v-for="(inst, index) in institution.partnerInstitutions" :title="inst.title">
                        <span class="custom_tag_name">{{inst.title}}</span>                          
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Categories </label>
                  </div>
                  <div class="fld_input">
                    <div class="custom_tags_container">
                      <span class="custom_tag" v-for="(customCategory, index) in institution.transferArticulationCustomCategories" :title="customCategory">
                        <span class="custom_tag_name">{{customCategory}}</span>                          
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Terms </label>
                  </div>
                  <div class="fld_input">
                    <div class="custom_tags_container">
                      <span class="custom_tag" v-for="(customTerm, index) in institution.transferArticulationCustomTerms" :title="customTerm">
                        <span class="custom_tag_name">{{customTerm}}</span>                          
                      </span>
                    </div>                    
                  </div>
                </div>                
              </div>
              <div class="row pg_fld_row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="fld_label">
                    <label class="label">Transfer Articulation Grades </label>
                  </div>
                  <div class="fld_input">
                    <div class="custom_tags_container">
                      <span class="custom_tag" v-for="(customGrade, index) in institution.transferArticulationCustomGrades" :title="'Text: ' + customGrade.text + ', Value: ' + customGrade.value">
                        <span class="custom_tag_name">{{customGrade.text}}</span>                          
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import InstitutionMenu from './InstitutionMenu'
  import InstitutionHeader from './InstitutionHeader'
  
  export default {
    name: 'institutionConfiguration',
    props: ['uuid'],
    components: {
      InstitutionMenu,
      InstitutionHeader
    },
    data: () => {
      return {
        uObj: JSON.parse(localStorage.getItem('userobj')),
        userrole: localStorage.getItem('userrole')
      }
    },
    mounted () {
      this.loadInstitution()
    },
    methods: {
      ...mapActions([
        'loadInstitutionDetail',
        'loadUserAdvisor',
        'loadLogDashboardActivity'
      ]),
  
      loadInstitution () {
        this.loadLogDashboardActivity({action: 'viewInstitutionConfigurationView', page: 'institutionConfigurationView', link: '', entityUuid: this.uuid})
        this.loadInstitutionDetail(this.uuid)
      },
  
      editConfigurationClicked () {
        return this.$router.push({ name: 'editInstitutionConfiguration', params: { uuid: this.uuid } })
      }
    },
    computed: {
      ...mapState({
        'institution': state => state.institution.institution
      })
    }
  }
</script>
<style scoped>
  .custom_tags_container {
    float: left;
    width: calc(100% - 30px);
    overflow: auto;
    max-height: 100px;
    margin-left: 15px;
  }
  .custom_tag {
    float: left;
    display: flex;
    margin: 0px 5px 5px 0px;
    border: 1px solid #b3b3b3;
    border-radius: 3px;
    color: #303030;
  }
  .custom_tag_name {
    width: 150px;
    padding: 5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: #e6e6e6;
  }
</style>


// WEBPACK FOOTER //
// src/app/institution/components/InstitutionConfiguration.vue